import NhimaReportComponent from 'components/Report/NhimaReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust path if necessary

const NhimaReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<NhimaReportComponent />
		</PermissionGuard>
	);
};

export default NhimaReport;
